import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import 'swiper/swiper.min.css';

; (function (window, document) {

	'use strict'

	function slideshowHeroInit() {
		Swiper.use([Navigation, Pagination, Scrollbar]);

		new Swiper('.swiper-container--hero', {
			slidesPerView: 1,
			spaceBetween: 0,

			pagination: {
				el: '.swiper-pagination',
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					current = current - 0.25;
					document.querySelector('.scrollbar-progress').style.width = (current / total) * 100 + "%";
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			scrollbar: {
				slidesPerView: 1,
				el: '.swiper-scrollbar',
				draggable: true,
				hide: false,
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
					//freeMode: true,
				},
			},
		});
	}
	function slideshowImageInit() {
		Swiper.use([Navigation, Pagination, Scrollbar]);

		new Swiper('.swiper-container--image', {
			slidesPerView: 'auto',
			spaceBetween: 24,
			freeMode: true,

			pagination: {
				el: '.swiper-pagination',
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					current = current - 0.25;
					document.querySelector('.scrollbar-progress').style.width = (current / total) * 100 + "%";
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			scrollbar: {
				slidesPerView: 1,
				el: '.swiper-scrollbar',
				draggable: true,
				hide: false,
			},
		});
	}

	// Start Animations when the page is ready.
	window.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.swiper-container--hero')) {
			//console.log( 'init hero carousel')
			slideshowHeroInit();
		}

		if (document.querySelector('.swiper-container--image')) {
			//console.log( 'init image carousel')
			slideshowImageInit();
		}
	})

})(window, document)